import React, { Fragment } from "react";
import Certifications from "../Certifications/Certifications";
import College from "../College/College";

function Education(props) {
    return (
        <Fragment>
            <div id="education">
                <College />
            </div>
        </Fragment>
    )
}
export default Education;
